import { render, staticRenderFns } from "./ClosePeriode.vue?vue&type=template&id=72df78be&scoped=true&"
import script from "./ClosePeriode.vue?vue&type=script&lang=ts&"
export * from "./ClosePeriode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df78be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72df78be')) {
      api.createRecord('72df78be', component.options)
    } else {
      api.reload('72df78be', component.options)
    }
    module.hot.accept("./ClosePeriode.vue?vue&type=template&id=72df78be&scoped=true&", function () {
      api.rerender('72df78be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/ClosePeriode.vue"
export default component.exports